export default __webpack_public_path__ + "static/media/WhiteLogoAndBlock.49e363e4.png";